export default "/_next/static/images/f0500c0c9c8714dba3d87994a729a57f.png";